import { useEffect, useState } from "react";
import { Download, FileText, ArrowUpRight } from "lucide-react";
import api, { formatDate } from "../lib/api";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

export default function Schedule() {
  const [docs, setDocs] = useState([]);
  const [comps, setComps] = useState([]);
  const [season, setSeason] = useState("2026/2027");

  useEffect(() => {
    api.get("/documents?category=rozpis").then((r) => setDocs(r.data)).catch(() => {});
    api.get("/competitions").then((r) => setComps(r.data)).catch(() => {});
    api.get("/settings").then((r) => r.data?.current_season && setSeason(r.data.current_season)).catch(() => {});
  }, []);

  return (
    <div data-testid="schedule-page">
      <Seo title="Rozpisy" description={`Rozpis súťaží ObFZ Levice pre sezónu ${season} — termíny kôl, úradné hracie časy a dokumenty na stiahnutie.`} />
      <PageHeader
        eyebrow={`Sezóna ${season}`}
        title={`Rozpis súťaže ${season}`}
        description="Oficiálny rozpis oblastných súťaží ObFZ Levice. Termíny, kategórie a propozície."
        breadcrumbs={[{ label: `Rozpis ${season}` }]}
      />

      <section className="section-pad bg-paper">
        <div className="wrap">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-7">
              <h2 className="display-md mb-6 border-b-2 border-ink-900 pb-4">Dokumenty rozpisu</h2>
              <div className="bg-white border border-ink-100 divide-y divide-ink-100">
                {docs.length === 0 && <div className="p-6 text-ink-500 text-sm">Žiadne dokumenty rozpisu.</div>}
                {docs.map((d, i) => (
                  <a key={d.id} href={d.file_url} target="_blank" rel="noopener noreferrer"
                     className="grid grid-cols-12 items-center gap-4 px-5 py-4 hover:bg-cream transition-colors group">
                    <div className="col-span-1 mono text-[11px] font-bold text-ink-400">{String(i + 1).padStart(2, "0")}</div>
                    <div className="col-span-9 md:col-span-9">
                      <div className="font-heading font-bold text-ink-900 group-hover:text-green-700 transition-colors">{d.name}</div>
                      <div className="mono text-[10px] uppercase tracking-widest text-ink-400 mt-0.5">{formatDate(d.date)} · {d.size}</div>
                    </div>
                    <div className="col-span-2 text-right">
                      <Download className="w-4 h-4 text-ink-400 inline group-hover:text-green-700" />
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="lg:col-span-5">
              <h2 className="display-md mb-6 border-b-2 border-ink-900 pb-4">Online výsledky</h2>
              <div className="bg-ink-900 text-white p-7 relative overflow-hidden">
                <div className="absolute top-0 right-0 stripe-accent w-28 h-28 opacity-20" />
                <p className="text-white/80 text-sm mb-5 leading-relaxed">
                  Aktuálne výsledky a tabuľky všetkých oblastných súťaží sú dostupné v oficiálnom systéme Futbalnet.
                </p>
                <div className="space-y-0 divide-y divide-white/10 border-t border-white/10 border-b">
                  {comps.map((c) => (
                    <a key={c.id} href={c.results_url} target="_blank" rel="noopener noreferrer"
                       className="flex items-center justify-between py-3 text-sm hover:text-green-100 group">
                      <span className="font-semibold">{c.name}</span>
                      <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
